import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

async function memorialExcelBuilder(projectData, solutionInputs) {
  const headers = [
    [
      "Nome",
      "Quantidade",
      "Diâmetro (cm)",
      "Rc (tf)",
      "Rt (tf)",
      "Sondagem",
      "C.A. (m)",
      "Comprimento Adotado (m)",
      "Rc,adm (tf)",
      "Rt,adm (tf)",
    ],
  ];

  const rows = projectData["solutions"][solutionInputs["selected_name"]].map(
    (solution, i) => [
      solution["name"],
      solution["parameters"]["quantity"],
      solution["parameters"]["diameter"],
      solution["parameters"]["rc"],
      solution["parameters"]["rt"],
      solution["investigation"],
      solution["parameters"]["ca"],
      solution["parameters"]["length"],
      solution["parameters"]["rc_adm"],
      solution["parameters"]["rt_adm"],
    ]
  );

  const sheetData = [...headers, ...rows];

  // Criar um novo workbook e uma planilha
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  // Definir larguras variáveis para cada coluna
  ws["!cols"] = [
    { wch: 8 }, // Nome
    { wch: 10 }, // Quantidade
    { wch: 14 }, // Diâmetro (cm)
    { wch: 8 }, // Rc (tf)
    { wch: 8 }, // Rt (tf)
    { wch: 20 }, // Sondagem
    { wch: 8 }, // C.A. (m)
    { wch: 25 }, // Comprimento Adotado (m)
    { wch: 10 }, // Rc,adm (tf)
    { wch: 10 }, // Rt,adm (tf)
  ];

  // Adicionar a planilha ao workbook
  XLSX.utils.book_append_sheet(wb, ws, solutionInputs["selected_name"]);

  // Gerar um Blob para download
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "Resumo de Fundações.xlsx");
}

export default memorialExcelBuilder;
